import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { trackEvent } from "../utils/Analytics";

function PurchaseSuccessView() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [status, setStatus] = useState("loading");
    const hasRun = useRef(false);


    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const sessionId = urlParams.get("session_id");
        if (sessionId === null || sessionId === undefined || sessionId === "") {
            console.error("No session ID found in URL parameters.");
            setStatus("error");
            return;
        }

        console.log("Entered useEffect with sessionId:", sessionId);
        // if not ready to run, or has already run, exit early
        var readyToRun = sessionId !== null && currentUser !== null;
        console.log("Ready to run:", readyToRun, "Current user:", "session id", sessionId, currentUser, "Has run:", hasRun.current);
        if (!readyToRun || hasRun.current) return;
        hasRun.current = true;
        console.log("Cleared and running");


        const verifyPurchase = async () => {
            console.log("Verifying purchase for session ID:", sessionId, " with url:", process.env.REACT_APP_VERIFY_STRIPE_SESSION_URL_PROD);
            try {
                const token = await currentUser.getIdToken();
                const res = await fetch(process.env.REACT_APP_VERIFY_STRIPE_SESSION_URL_PROD, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ sessionId }),
                    mode: "cors",
                });

                const result = await res.json();
                console.log("Stripe session verification result:", result);

                if (!res.ok) {
                    console.log("Error verifying Stripe session:", result);
                    alert(result.error || "An error occurred while verifying your purchase.");
                    if (result.error === "Session already processed") {
                        setStatus("already-processed");
                    } else if (result.error === "Stripe session not found") {
                        setStatus("not-found");
                    } else {
                        setStatus("error");
                    }
                    return;
                }

                trackEvent("Purchase", "Stripe session verified", "Credits granted", null, {
                    user_id: currentUser.uid,
                    session_id: sessionId,
                    deck_type: result.deckType,
                });

                // Check if the deck type is standard-digital or custom-digital
                if (result.deckType === "standard-digital" && result.deckId) {
                    setStatus("standard-success");
                    setTimeout(() => navigate(`/deck/${result.deckId}`), 1000);
                } else if (result.deckType === "custom-digital") {
                    setStatus("custom-success");
                    setTimeout(() => navigate("/customize/questions"), 1000);
                } else {
                    console.error("Unknown deck type:", result.deckType);
                    alert("An unexpected error occurred. Please try again.");
                    setStatus("error");
                }
            } catch (err) {
                alert(err.message || "An error occurred while verifying your purchase.");
                console.error("Error verifying Stripe session:", err);
                setStatus("error");
            }
        };

        verifyPurchase();
    }, [currentUser, navigate]);

    return (
        <div className="pt-24 text-center">
            {status === "loading" && <p>Verifying your purchase...</p>}
            {status === "custom-success" && <p>Purchase confirmed! Redirecting to customize your deck...</p>}
            {status === "error" && <p>Sorry, something went wrong! Please contact us at support@imoonshots.com or try again.</p>}
            {status === "already-processed" && <p>Sorry, this credit was already used for a deck. If you have questions, contact us at support@imoonshots.com or try again.</p>}
            {status === "not-found" && <p>Sorry, credit not found. Please check your purchase or contact support at support@imoonshots.com.</p>}
            {status === "standard-success" && <p>Purchase confirmed! Redirecting to your standard digital deck...</p>}
        </div>
    );
}

export default PurchaseSuccessView;
